let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eqY2L")).then(() => parcelRequire('aoP5b'));